import {Component, Input} from '@angular/core';
import {Plans} from '@ox/typings';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ShopDataService} from '@webu/data';
import {TrackingService} from '@ox/data';
@Component({
  selector: 'webu-roll-in-roll-out-modal',
  templateUrl: './roll-in-roll-out-modal.html'
})
export class RollInRollOutModalComponent {
  @Input() product: Plans;
  @Input() selected: Plans[];
  @Input() text: string;

  constructor(
    public bsModalRef: BsModalRef,
    private shopDataService: ShopDataService,
    public trackingService: TrackingService
    
  ) {}
  
  getCopy(copyKey: string) {
    return this.shopDataService.getGenericCopy(copyKey);
  }
}